import compareList from "./components/compareList.vue";

export function createApp() {
    Vue.component( "compare-list", compareList );
}
